import UploadSingleFile from "../../../common/custom/UploadSingleFile";
import { ApplicationDetailsDto } from "../Models";

interface Props {
  application: ApplicationDetailsDto;
}
export default function DocumentsList({ application }: Props) {
  return (
    <>
      {application.documents.map((doc) => (
        <UploadSingleFile key={doc.id} document={doc} />
      ))}
    </>
  );
}
